var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M959 512L959 540",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 959.5,
    cy: 507.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M956.105 516C955.637 516 955.236 515.834 954.903 515.501C954.57 515.168 954.403 514.768 954.403 514.3C954.403 513.833 954.57 513.432 954.903 513.099C955.236 512.766 955.637 512.6 956.105 512.6C956.573 512.6 956.973 512.766 957.306 513.099C957.64 513.432 957.806 513.833 957.806 514.3C957.806 514.768 957.64 515.168 957.306 515.501C956.973 515.834 956.573 516 956.105 516ZM964.613 516C964.145 516 963.744 515.834 963.411 515.501C963.078 515.168 962.911 514.768 962.911 514.3C962.911 513.833 963.078 513.432 963.411 513.099C963.744 512.766 964.145 512.6 964.613 512.6C965.081 512.6 965.481 512.766 965.814 513.099C966.148 513.432 966.314 513.833 966.314 514.3C966.314 514.768 966.148 515.168 965.814 515.501C965.481 515.834 965.081 516 964.613 516ZM955.382 502.4L957.423 506.65H963.379L965.719 502.4H955.382ZM954.573 500.7H967.122C967.449 500.7 967.697 500.845 967.867 501.136C968.037 501.426 968.044 501.72 967.888 502.018L964.868 507.457C964.712 507.741 964.503 507.96 964.24 508.116C963.978 508.272 963.691 508.35 963.379 508.35H957.041L956.105 510.05H966.314V511.75H956.105C955.467 511.75 954.985 511.47 954.658 510.911C954.332 510.351 954.318 509.795 954.616 509.242L955.764 507.16L952.702 500.7H951V499H953.765L954.573 500.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.be86ebec4572551be238a9513df9befb.svg";
export { ForwardRef as ReactComponent };